<template>
  <b-card no-body class="shadow-none b-all">
    <table id="demo-foo-addrow" :class="[border ? 'table-bordered' : '', stripe ? 'table-striped' : '']" class="table table-hover contact-list" data-page-size="10">
      <thead v-if="showHead">
        <tr>
          <th v-if="choice" style="width: 40px;">
            <div class="checkbox" style="width: 40px;">
              <input @change="checkAllFun" type="checkbox" :id="'checkboxAll' + id" v-model="checkedAll">
              <label class="th_label" :for="'checkboxAll' + id"></label>
            </div>
          </th>
          <th v-for="(item, index) in columns" :width="item.width ? parseInt(item.width) + 'px' : ''" :key="index" style="padding: 0 0.75rem;">
            <div style="height: 46px;line-height: 46px;">
              <span>{{item.title}}</span>
              <Caret @sort-change="sortFun" style="display: inline-block;" :item="item" class="relative caret_group" v-if="item.sort"></Caret>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index" :class="index%2 === 0 ? 'odd' : 'even'">
          <td v-if="choice">
            <div class="checkbox">
              <input @change="checkFun" type="checkbox" :id="'checkbox' + id + index" :value="item" v-model="checkedNames">
              <label class="th_label" :for="'checkbox' + id + index"></label>
            </div>
          </td>
          <td :width="th.width ? parseInt(th.width) + 'px' : ''" v-for="(th, thi) in columns" :key="thi">
            <div v-if="slotName.indexOf(th.key) >= 0">
              <slot :name="th.key" :data="item[th.key]" :item="item" :index="index"></slot>
            </div>
            <div v-else>
              {{item[th.key]}}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="data.length === 0" class="text-center" style="background: #f2f4f8;">
      <EmptyHint></EmptyHint>
    </div>
    <div v-if="isLoading" class="table_loading">
      <div>
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10" class="path"></circle>
        </svg>
      </div>
    </div>
  </b-card>

</template>

<script>
  import Caret from './caret.vue'
  export default {
    name: 'BusTable',
    props: {
      id: {
        type: String,
        default: 'table'
      },
      showHead: {
        type: Boolean,
        default: true
      },
      columns: {
        type: Array,
        default: () => []
      },
      data: {
        type: Array,
        default: () => []
      },
      choice: {
        type: Boolean,
        default: null
      },
      width: {
        type: Boolean,
        default: null
      },
      border: {
        type: Boolean,
        default: null
      },
      stripe: {
        type: Boolean,
        default: null
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    components: {Caret},
    data () {
      return {
        checkedAll: false,
        checkedNames: []
      }
    },
    watch: {
      isLoading () {
        this.checkedNames = []
        this.checkedAll = false
      }
    },
    computed: {
      slotName () {
        let nameArr = []
        for (var name in this.$scopedSlots) {
          nameArr.push(name)
        }
        return nameArr
      }
    },
    methods: {
      checkAllFun () {
        this.checkedAll ? this.checkedNames = this.data : this.checkedNames = []
        this.$emit('change', this.checkedNames)
      },
      checkFun () { // 单独选择
        this.checkedNames.length === this.data.length ? this.checkedAll = true : this.checkedAll = false
        this.$emit('change', this.checkedNames)
      },
      sortFun (i, data) {
        data.sort(i, data)
        // fun(data)
      },
      clearBoth() {
        this.checkedNames = []
        this.checkedAll = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  #demo-foo-addrow{
    margin: 0;
    width: 100%;
  }
  .th_label{
    height: 20px;
    display: block;
    margin-bottom: 0;
    margin: 0 auto;
    width: 22px;
    padding: 0;
  }
  .contact-list td{
    padding: 15px 10px;
  }
  .table-bordered th {
    border: 1px solid #f3f1f1;
  }
  .caret_group{
    display: inline-block;
    width: 20px;
    height: 100%;
    margin-left: 4px;
    margin-top: -1px;
    vertical-align: middle;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    &>i{
      width: 20px;
      text-align: center;
    }
  }
  .table_loading{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.9);
  }
  .table_loading>div{
    width: 35px;
    height: 35px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .circular {
    -webkit-animation: rotate 2s linear infinite;
    animation: rotate 2s linear infinite;
    height: 100%;
    -webkit-transform-origin: center center;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/table/index.vue